// extracted by mini-css-extract-plugin
export default {"token":"AccessTokens_token__nOjeo"};